import React from 'react';
import { Modal } from 'antd';
import { AddTestItemsForm } from './AddTestItemsForm';
import { useTranslation } from 'react-i18next';

interface AddTestItemsModalProps {
    visible: boolean;
    testRunId: number;
    projectId: number;
    onSuccess: () => void;
    onCancel: () => void;
}

export const AddTestItemsModal: React.FC<AddTestItemsModalProps> = ({
    visible,
    testRunId,
    projectId,
    onSuccess,
    onCancel
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            title={t('testRuns.addTestItems')}
            open={visible}
            onCancel={onCancel}
            footer={null}
            width={800}
            destroyOnHidden
        >
            <AddTestItemsForm
                testRunId={testRunId}
                projectId={projectId}
                onSuccess={onSuccess}
                onCancel={onCancel}
            />
        </Modal>
    );
}; 